import { useSearchParams } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Google OAuth login. "Sign in with Google" is a plain `<a>`, not a fetch
 * call — the OAuth redirect chain is a real top-level browser navigation
 * to Google and back, which `fetch` can't drive. The backend
 * (`dashboard_api/session.py`) handles the whole handshake and lands the
 * browser back on `/` with a session cookie already set.
 */
export function LoginPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  return (
    <main className="flex min-h-screen items-center justify-center">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>DGP Dashboard</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {error === "unauthorized" && (
            <p className="text-sm text-destructive">
              Your Google account isn&apos;t authorized for this app.
            </p>
          )}
          {error === "login_failed" && (
            <p className="text-sm text-destructive">
              Sign-in failed. Please try again.
            </p>
          )}
          <Button asChild className="w-full">
            <a href="/v1/dashboard/auth/login">Sign in with Google</a>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
